// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';

export const FixedContent = styled.div`
  width: 100%;
  height: calc(100% - 100px);

  position: fixed;
  bottom: 0;
  left: 0;

  transition: all 0.5s ease;
  background: ${({ theme }) => theme.colors.overlayBg};
  border-radius: ${({ theme }) => `${theme.borders.radius40} ${theme.borders.radius40} 0 0`};
  box-shadow: ${({ theme }) => theme.elevations.shadow400};
  z-index: 7;
  animation: slideInUp 0.5s ease;
  animation-fill-mode: forwards;
  > html {
    background-color: ${({ theme }) => theme.colors.overlayBg};
  }
  .story-widget{
    background-color: ${({ theme }) => theme.colors.overlayBg};
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 30px;
  top: 20px;
  cursor: pointer;
`;

export const MwebIFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  border-radius: ${({ theme }) => `${theme.borders.radius40} ${theme.borders.radius40} 0 0`};
  padding-top: ${({ theme }) => theme.spacing.spacing200};
`;

export const DwebIFrame = styled.iframe`
  height: 100%;
  width: 100%;
  border: 0;
  display: block;
`;

export const DwebOverlaySheet = styled(BaseOverlaySheet)`
  background-color: #fff;
  height: 100%;
  width: 30%;
  background-color: #fff;
  left: initial;
  overflow-y: auto;
  overflow-x: hidden;
`;
